"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const facility = {
    name: 'pt-facility',
    tableType: 'dim',
    grain: [],
    joins: [],
    tableGrain: [
        '!pt-facility'
    ],
    foreignKeys: [
        'cbsa:pt-facility:cbsa',
        'fips:pt-facility:fips',
        'abbreviated_state:pt-facility:abbreviated_state'
    ],
    facts: [
        'pt-codedetailfacthospital',
        'pt-codedetailfactpayer',
        'pt-servicelinecffactrecent-payer',
        'pt-servicelinecffactrecent-hospital',
        'pt-hospitalqualityscores'
    ]
};
const providerGroup = {
    name: 'pt-providergroup',
    tableType: 'dim',
    grain: [],
    tableGrain: [
        '!pt-providergroup'
    ],
    foreignKeys: [
        'cbsa:pt-providergroup:cbsa',
    ]
};
const serviceLineCF = {
    name: 'pt-servicelinecffact',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!pt-facility'
    ],
    foreignKeys: [
        'facilityid:pt-facility:facilityid'
    ]
};
const codeDetail = {
    name: 'pt-codedetailfact',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!pt-facility'
    ],
    foreignKeys: [
        'facilityid:pt-facility:facilityid'
    ]
};
const codeDetailFactHospital = {
    name: 'pt-codedetailfacthospital',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!pt-facility'
    ],
    foreignKeys: [
        'facilityid:pt-facility:facilityid'
    ]
};
const codeDetailFactPayer = {
    name: 'pt-codedetailfactpayer',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!pt-facility'
    ],
    foreignKeys: [
        'facilityid:pt-facility:facilityid',
    ]
};
const codeDetailFactPayerProfessional = {
    name: 'pt-codedetailfactpayerprofessional',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!pt-providergroup'
    ],
    foreignKeys: [
        'torch_provider_group_id:pt-providergroup:torchprovidergroupid'
    ]
};
const serviceLineCFFactRecentHospital = {
    name: 'pt-servicelinecffactrecent-hospital',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!pt-facility',
        '!pt-providergroup'
    ],
    foreignKeys: [
        'facilityid:pt-facility:facilityid',
        'torch_provider_group_id:pt-providergroup:torchprovidergroupid'
    ]
};
const serviceLineCFFactRecentPayer = {
    name: 'pt-servicelinecffactrecent-payer',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!pt-facility',
        '!pt-providergroup'
    ],
    foreignKeys: [
        'facilityid:pt-facility:facilityid',
        'torch_provider_group_id:pt-providergroup:torchprovidergroupid'
    ]
};
exports.default = [
    facility,
    providerGroup,
    serviceLineCF,
    codeDetail,
    codeDetailFactHospital,
    codeDetailFactPayer,
    codeDetailFactPayerProfessional,
    serviceLineCFFactRecentHospital,
    serviceLineCFFactRecentPayer
];
